module.exports = __webpack_public_path__ + "img/futb-02.6c087615.jpg";